module.exports = __webpack_public_path__ + "static/media/8.83d5a9c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/alphabet/8.jpg
// module id = 103
// module chunks = 0